/**
 * 短途接驳
 */

export default {
  // 短途接驳的费用支持按照运单上的体积分摊
  use_volumn_db_average: ['88114'], // 202506161359500176349、202506281519295204839
  // 运单审核页面开启复审核功能
  order_recheck: ['88114'] // 202506161359500176349
}
